export var AlertType;
(function (AlertType) {
    AlertType["success"] = "alert-success";
    AlertType["danger"] = "alert-danger";
    AlertType["warning"] = "alert-warning";
    AlertType["info"] = "alert-info";
    AlertType["secondary"] = "alert-secondary";
    AlertType["light"] = "alert-light";
})(AlertType || (AlertType = {}));
